import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { useTitle } from "../hooks/useTitle";
import { routes } from "../helpers/Routes";
import { useProductos } from "../hooks/useProductos";
import Header from "../components/layout/Header";
import Footer from "../components/layout/Footer";
import bici1 from "../assets/bici1.png"
import visa from "../assets/visa.svg";
import mastercard from "../assets/mastercard.svg";
import americanexpress from "../assets/americanexpress.svg";
import Whatsapp from "../assets/Whatsapp.svg"
import codinensa from "../assets/codensa.svg";
import visadebito from "../assets/visa-debito.svg";
import mastercarddebito from "../assets/matercard-debito.svg";
import efecty from "../assets/efecty.svg";
import Cart from "../assets/cart.png";
import CarritoCompras from "../components/CarritoCompras";
import { useForm } from "../hooks/useForm";
import { useAuth } from "../hooks/useAuth";
import { Helmet } from "react-helmet-async";
import Product from "../components/Products/produt";
import Loader from "../components/Loader";
import axios from "axios";
const Producto = () => {
    const { usuario } = useAuth();
    const { cart, productos, producto, addCart, getProducto, formatoCOP } = useProductos();
    const { form, onChange } = useForm({ cantidad: 1, size: "450 - XS - 1.54" });
    const { cantidad, size } = form;
    const [openCart, setOpenCart] = useState(false);
    const [comprar, setComprar] = useState(false);

    const { pathname } = useLocation()

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    const { id } = useParams();
    let navigate = useNavigate();

    useEffect(() => {
        if (id) {
            getProducto(id);
        }
    }, [id]);

    useEffect(() => {
        if (comprar) {
            navigate(routes.checkout);
        }
    }, [comprar])

    const title = `${producto?.nombre}`;
    // const description = `Bicicletas de ruta`;
    // useTitle({ title, description });

    const images = typeof producto?.img === "string" ? JSON.parse(producto?.img) : producto?.img;

    const comprar_ahora = (color, sizeC) => {
        console.log(sizeC)
        async function getIP() {
            const ip = await axios.get("https://api.ipify.org?format=json");
            return ip.data;  // Devuelve los datos directamente
        }

        async function showIP() {
            const data = await getIP();
            addCart({ ...producto, cantidad, color, id_usuario: usuario?.id_usuario, size: sizeC, ip: data?.ip }).then(r => {
                setComprar(true);
            }).catch(e => {
                console.log(e)
            })

        }
        showIP()

    }


    // Estado para la imagen principal
    const [mainImageIndex, setMainImageIndex] = useState(0);

    // Función para manejar el clic en una imagen de la lista
    const handleImageClick = (index) => {
        setMainImageIndex(index);
    };



    if (producto === null) {
        return <Loader></Loader>;
    }

    return (
        <>
            <Helmet prioritizeSeoTags={true}>
                <title>{`${title} | Bicicletas java colombia`}</title>
                <meta property="og:type" content="website" />
                <meta property="og:title" content={`${title} | Bicicletas java colombia`} />
                <meta property="og:url" content="https://bicicletasjavacolombia.com/" />
                <meta property="og:image" content="https://bicicletasjavacolombia.com/src/assets/logo-footer.png" />
                <meta property="og:description" content={`${producto?.nombre} ${producto?.descripcion}`} />
            </Helmet>
            <div className="wrapper" style={{ maxWidth: "100%", background: "#000000" }}>
                <Header openCart={openCart} setOpenCart={setOpenCart} />
                <CarritoCompras setOpenCart={setOpenCart} openCart={openCart} />
                <Product comprar_ahora={comprar_ahora} />
                <Footer />
            </div>
        </>
    );
}

export default Producto;